@if (entries$ | async; as entries) {
  @if (entries.length > 0) {
    <div class="cart-items" >
      <div class="cart-items-header">
        <div>Product</div>
        <div style="text-align: center;">Price</div>
        <div style="text-align: center;">Qty</div>
        <div style="text-align: center;">Sales Unit</div>
        <div style="text-align: center;">Total</div>
        <div></div>
      </div>
      <!-- <knbr-cwt-spinner *ngIf="isCartEntrySpinner" [className]="'cart-loader'"></knbr-cwt-spinner> -->
      @if ({spinnerActive : commonService.showInlineSpinner$ | async}; as $) {
        @if ($.spinnerActive == 'cart-loader') {
          <knbr-cwt-spinner class="cart-spinner-backdrop" [calssName]="'cart-loader'"></knbr-cwt-spinner>
        }
      }
      @for (entry of entries; track entry) {
        <cwt-cart-item-list [items]="entry">
        </cwt-cart-item-list>
      }
    </div>
  }
}